import * as React from "react";
import { FunctionComponent } from "react";

// Stone colours per theme: highlight, body and shadow of a radial gradient.
const PALETTES: Record<string, string[][]> = {
    ceviz: [["#fff1c9", "#e39a32", "#7d4610"], ["#d4fff5", "#2fa597", "#0c4a42"], ["#fffaf0", "#e2d3b6", "#94815f"], ["#ffd0c7", "#c94a3b", "#621a12"], ["#e6ecff", "#6b84c9", "#263a73"]],
    gece: [["#ffffff", "#dfe3ee", "#8a92ad"], ["#f3f6ff", "#8fa8ff", "#2b3f92"], ["#fff6e6", "#e8bd78", "#8b5d1f"], ["#ffeef6", "#e7a3c4", "#8a3c62"]],
    yesim: [["#e2ffee", "#3f9f6f", "#134a2d"], ["#8d939a", "#2b2f35", "#08090b"], ["#ffffff", "#efe9df", "#a59a88"], ["#ffe8c7", "#d38a3a", "#6e3c0d"]],
};

// A repeatable pseudo random number in [0, 1).
function random(seed: number): number {
    const x = Math.sin(seed * 12.9898 + 78.233) * 43758.5453;
    return x - Math.floor(x);
}

// The stones of a pit or store, scattered around its centre on a sunflower spiral. The same count and seed always
// give the same picture, so stones only move when the count changes.
const Stones: FunctionComponent<{ count: number, seed: number, themeId: string }> = ({ count, seed, themeId }) => {
    const palette = PALETTES[themeId] ?? PALETTES.ceviz;
    const stones = [];
    for (let i = 0; i < count; i++) {
        const angle = i * 2.39996 + seed;
        const distance = count === 1 ? 0 : Math.sqrt((i + 0.6) / count);
        const x = 50 + Math.cos(angle) * distance * 33 + (random(seed + i) - 0.5) * 3;
        const y = 50 + Math.sin(angle) * distance * 33 + (random(seed + i * 3) - 0.5) * 3;
        const [light, body, dark] = palette[Math.floor(random(seed * 5 + i * 7.1) * palette.length)];
        stones.push(<span key={i} className="st" style={{
            left: `${x.toFixed(2)}%`,
            top: `${y.toFixed(2)}%`,
            background: `radial-gradient(circle at 34% 28%, ${light} 0%, ${body} 55%, ${dark} 100%)`,
        }} />);
    }
    return <>{stones}</>;
};

export default Stones;
